import { ApiService } from "@/services/api/ApiService";
import type { AgentMailbox, AgentMailboxListResponse, AgentMailboxUpdateInput } from "@/types/agent-mailboxes";

export class AgentMailboxAdminService {
  static async list(limit: number = 50, offset: number = 0): Promise<AgentMailboxListResponse> {
    const response = await ApiService.invoke<AgentMailboxListResponse>({
      resource: "agent-mailboxes",
      action: "all",
      data: { limit, offset },
    });
    return {
      mailboxes: response.mailboxes ?? [],
      count: response.count ?? 0,
      limit: response.limit ?? limit,
      offset: response.offset ?? offset,
    };
  }

  static async update(id: string, input: AgentMailboxUpdateInput): Promise<void> {
    await ApiService.invoke({
      resource: "agent-mailboxes",
      action: "update",
      id,
      data: input,
    });
  }

  static async deprovision(id: string): Promise<void> {
    await ApiService.invoke({
      resource: "agent-mailboxes",
      action: "delete",
      id,
    });
  }
}
